export const seasonEntityExportFields = [
  {
    titleIntlKey: "seasonEntity.columns.competition.title",
    fields: ["competitionId", "competitionExternalId", "competitionName"],
  },
  {
    titleIntlKey: "seasonEntity.columns.season.title",
    fields: ["seasonId", "seasonExternalId", "seasonName"],
  },
  {
    titleIntlKey: "seasonEntity.columns.entity.title",
    fields: [
      "entityName",
      "entityNameFullLatin",
      "entityCodeLocal",
      "entityCodeLatin",
      "entityId",
      "entityExternalId",
      "entityGender",
      "entityAgeGroup",
      "entityStandard",
      "entityDiscipline",
      "entityStatus",
    ],
  },
  {
    titleIntlKey: "seasonEntity.columns.seasonEntity.title",
    fields: ["status", "rosterStatus", "seed"],
  },
  {
    titleIntlKey: "seasonEntity.columns.conference.title",
    fields: ["conferenceId", "conferenceExternalId", "conferenceName"],
  },
  {
    titleIntlKey: "seasonEntity.columns.division.title",
    fields: ["divisionId", "divisionExternalId", "divisionName"],
  },
];

export const defaultSeasonEntityExportFieldNames = [
  "entityName",
  "entityCodeLocal",
  "entityId",
  "entityGender",
  "entityAgeGroup",
  "entityStandard",
  "entityDiscipline",
  "entityStatus",
];
